module.exports = __webpack_public_path__ + "img/百盛估价@2x.930a911b.png";